module.exports = __webpack_public_path__ + "img/portfolio_bootstrap_m.b2ee9f24.jpg";